import { Button, Card, Flex, Text, Heading, TextField, Box } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { AppDatePicker } from 'shared/components';
import { useSliderManager } from '../slider-manager.provider';
import { DateUtilsService } from 'shared/utils/date-utils.service';

const SliderMangerFiltersView = () => {
   const sliderManager = useSliderManager();
   return (
      <Card m="3" className="slider-filters">
         <Flex direction="column" gap="2">
            <Heading as="h4" weight="medium" color="gray">
               Filters
            </Heading>
            <Box minWidth="300px">
               <TextField.Root
                  placeholder="Search Company name, Email or Id"
                  size="3"
                  color="blue"
                  autoComplete="off"
                  onChange={(e) => sliderManager.onSearchChange(e.target.value)}
               />
            </Box>
         </Flex>

         <Flex maxWidth="450px" gap="3">
            <Box width="200px">
               <Text mb="2" color="gray">
                  Date from:
               </Text>
               <AppDatePicker
                  inputProps={{
                     value: sliderManager.draftFilters.dateFrom,
                     onChange: (e) => {
                        const value = e.target.value;
                        if (DateUtilsService.isValidDate(value)) {
                           sliderManager.onDateFromChange(value);
                        }
                     },
                     size: '3',
                     placeholder: 'dd.mm.yyy',
                  }}
                  inputDateFormat="dd.MM.yyyy"
                  outputDateFormat="dd.MM.yyyy"
                  onClear={() => {
                     sliderManager.onDateFromChange('');
                  }}
                  onSelect={(e) => {
                     sliderManager.onDateFromChange(e);
                  }}
               />
            </Box>

            <Box width="200px">
               <Text mb="2" color="gray">
                  Date to:
               </Text>
               <AppDatePicker
                  inputProps={{
                     value: sliderManager.draftFilters.dateTo,
                     onChange: (e) => {
                        const value = e.target.value.trim();
                        if (DateUtilsService.isValidDate(value)) {
                           sliderManager.onDateToChange(value);
                        }
                     },
                     size: '3',
                     placeholder: 'dd.mm.yyy',
                  }}
                  inputDateFormat="dd.MM.yyyy"
                  outputDateFormat="dd.MM.yyyy"
                  onClear={() => {
                     sliderManager.onDateToChange('');
                  }}
                  onSelect={(e) => {
                     sliderManager.onDateToChange(e);
                  }}
               />
            </Box>
         </Flex>

         <Flex>
            <Button
               size="3"
               color="blue"
               highContrast
               onClick={() => {
                  sliderManager.onApplyFilters();
               }}
            >
               Apply
            </Button>
         </Flex>
      </Card>
   );
};

export const SliderManagerFilters = observer(SliderMangerFiltersView);
